// THIS FILE WAS AUTO GENERATED, UPDATE THE i18n FILES

import { HBinput, i18nLoad } from "@cervval.js/i18n/src/i18n.tools";

export type I18nType = {
    addButton: string,
    checkboxFalseStringValue: string,
    checkboxTrueStringValue: string,
    confirmDelete: string,
    deleteButton: string,
    editButton: string,
    emptyState: {
        clearFilter: {
            label: string
        }
    },
    footerInfo: {
        displayableRowsCount: {
            noFilter: {
                plural: (input: { nbrTotalRows: HBinput }) => string,
                singular: (input: { nbrTotalRows: HBinput }) => string
            },
            withFilter: {
                plural: (input: { nbrDisplayableRows: HBinput, nbrTotalRows: HBinput }) => string,
                singular: (input: { nbrDisplayableRows: HBinput, nbrTotalRows: HBinput }) => string
            }
        },
        selectedRowsCount: {
            plural: (input: { nbrSelectedRows: HBinput }) => string,
            singular: (input: { nbrSelectedRows: HBinput }) => string
        }
    },
    hierarchy: {
        collapse: {
            all: string
        },
        expand: {
            all: string
        },
        selectChildren: {
            selectAll: string,
            shortSelectAll: string,
            shortUnselectAll: string,
            unselectAll: string
        }
    },
    impossibleToMultiSelect: string,
    multipleLineSelected: string,
    multiselect: {
        selectAll: string,
        unselectAll: string
    },
    noDataToDisplay: string,
    noLineSelected: string,
    paginator: {
        label: {
            entries: string,
            of: string,
            pages: string,
            to: string
        },
        select: {
            all: string
        }
    },
    searchInputLabel: string,
    searchInputLabelJSRegex: string,
    searchLabel: string,
    selectLineToDelete: string,
    selectLineToEdit: string
};

const i18n_en = require("./_en.i18n"); // hash_en=2110091008666452#
const i18n_fr = require("./_fr.i18n"); // hash_fr=3356204472438666#

/** @returns the i18n for provided lang (fallback on app.lang if i18n not found for lang) */
export function i18n(lang?: string): I18nType {
    return i18nLoad<I18nType>(lang, ["en", "fr"], (langToLoad: string) => {
        switch (langToLoad) {
            case "en": return i18n_en;
            case "fr": return i18n_fr;
            default:
        }
        return null;
    });
}